// BoosterModal.js
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import greenCPU from '../assets/images/greenCPU.png';
import blueCPU from '../assets/images/blueCPU.png';
import yellowCPU from '../assets/images/yellowCPU.png';

const ModalOverlay = styled.div`
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.85) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 999999 !important;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadeIn 0.2s ease-in-out !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContainer = styled.div`
  background-color: white;
  width: 90%;
  max-width: 400px;
  border-radius: 20px;
  padding: 0;
  box-sizing: border-box;
  animation: slideIn 0.3s ease-in-out;
  overflow: hidden;
  
  @keyframes slideIn {
    from { transform: translateY(20px); opacity: 0.8; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  position: relative;
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  color: #000;
  text-align: left;
  font-weight: 600;
  margin: 0;
  padding: 0;
  line-height: 1.1;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

const CPUGrid = styled.div`
  display: flex;
  padding: 0 20px 10px;
  gap: 15px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  
  /* Hide scrollbar but keep functionality */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  
  /* Ensure items don't shrink */
  & > * {
    flex-shrink: 0;
    min-width: 120px; /* Minimum width for each CPU card */
  }
`;

const CPUCard = styled.div`
  flex: 0 0 auto;
  width: 120px;
  background-color: ${props => props.$selected ? '#e3f2fd' : '#f8f9fa'};
  border: ${props => props.$selected ? '2px solid #2196F3' : '2px solid transparent'};
  border-radius: 12px;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.$selected ? '#e3f2fd' : '#f0f0f0'};
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const CPUImage = styled.img`
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin-bottom: 8px;
`;

const InfoSection = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
`;

const InfoLabel = styled.span`
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const InfoValue = styled.span`
  font-weight: 500;
  color: #000;
`;

const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 15px 0;
`;

const QuantityButton = styled.button`
  background-color: #f0f0f0;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e0e0e0;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const QuantityDisplay = styled.span`
  font-size: 18px;
  font-weight: bold;
  min-width: 30px;
  text-align: center;
`;

const RentButton = styled.button`
  background-color: #000;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  padding: 15px;
  width: 100%;
  margin-top: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #333;
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const CPUs = [
  {
    id: 'green',
    name: 'Green CPU',
    image: greenCPU,
    dailyProfit: 33.33312,
    totalProfit: 999.9936,
    color: '#4CAF50'
  },
  {
    id: 'blue',
    name: 'Blue CPU',
    image: blueCPU,
    dailyProfit: 66.66624,
    totalProfit: 1999.9872,
    color: '#2196F3'
  },
  {
    id: 'yellow',
    name: 'Yellow CPU',
    image: yellowCPU,
    dailyProfit: 133.33248,
    totalProfit: 3999.9744,
    color: '#FFC107'
  }
];

const BoosterModal = ({ isOpen, onClose }) => {
  const [selectedCPU, setSelectedCPU] = useState('blue'); // Default to blue (medium)
  const [quantity, setQuantity] = useState(1);
  
  const currentCPU = CPUs.find(cpu => cpu.id === selectedCPU);
  const rentPrice = 10000; // 10,000 $PXL as shown in reference
  const totalPrice = rentPrice * quantity;
  
  // Portal root element
  const portalRoot = document.getElementById('modal-root') || document.createElement('div');
  
  // Create portal root if it doesn't exist
  React.useEffect(() => {
    if (!document.getElementById('modal-root')) {
      portalRoot.id = 'modal-root';
      portalRoot.style.position = 'fixed';
      portalRoot.style.top = '0';
      portalRoot.style.left = '0';
      portalRoot.style.width = '100%';
      portalRoot.style.height = '100%';
      portalRoot.style.zIndex = '999999';
      document.body.appendChild(portalRoot);
    }
    
    return () => {
      if (portalRoot.parentElement && !isOpen) {
        document.body.removeChild(portalRoot);
      }
    };
  }, [isOpen, portalRoot]);
  
  // Handle modal open/close effects
  React.useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
      
      // Hide other UI elements
      document.querySelectorAll('header, footer, nav, .HeaderWrapper, .CoinInfoContainer').forEach(elem => {
        if (elem) {
          elem.style.display = 'none';
        }
      });
      
      // Set modal z-index
      const modalRoot = document.getElementById('modal-root');
      if (modalRoot) {
        modalRoot.style.zIndex = '2147483647';
        modalRoot.style.position = 'fixed';
        modalRoot.style.top = '0';
        modalRoot.style.left = '0';
        modalRoot.style.width = '100vw';
        modalRoot.style.height = '100vh';
      }
      
      // Disable body scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    }
    
    return () => {
      document.body.classList.remove('modal-open');
      
      // Restore UI elements
      document.querySelectorAll('header, footer, nav, .HeaderWrapper, .CoinInfoContainer').forEach(elem => {
        if (elem) {
          elem.style.display = '';
        }
      });
      
      // Re-enable body scrolling
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const handleQuantityChange = (delta) => {
    setQuantity(prev => Math.max(1, prev + delta));
  };
  
  const handleRent = () => {
    // In a real app, this would make an API call to rent the miner
    alert(`Rented ${quantity} ${currentCPU.name}(s) for ${totalPrice.toLocaleString()} $PXL!`);
    onClose();
  };
  
  return ReactDOM.createPortal(
    <ModalOverlay onClick={onClose} className="modal-overlay">
      <ModalContainer onClick={e => e.stopPropagation()}>
        <HeaderSection>
          <ModalTitle>Booster</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </HeaderSection>
        
        <CPUGrid>
          {CPUs.map((cpu) => (
            <CPUCard 
              key={cpu.id}
              $selected={selectedCPU === cpu.id}
              onClick={() => setSelectedCPU(cpu.id)}
            >
              <CPUImage src={cpu.image} alt={cpu.name} />
            </CPUCard>
          ))}
        </CPUGrid>
        
        <InfoSection>
          <InfoRow>
            <InfoLabel>Rent Period</InfoLabel>
            <InfoValue>30 days</InfoValue>
          </InfoRow>
          
          <InfoRow>
            <InfoLabel>Daily profit 💎</InfoLabel>
            <InfoValue>{(currentCPU.dailyProfit * quantity).toFixed(5)} DOGE</InfoValue>
          </InfoRow>
          
          <InfoRow>
            <InfoLabel>Total profit 💎</InfoLabel>
            <InfoValue>{(currentCPU.totalProfit * quantity).toFixed(4)} DOGE</InfoValue>
          </InfoRow>
          
          <QuantityControls>
            <QuantityButton 
              onClick={() => handleQuantityChange(-1)}
              disabled={quantity <= 1}
            >
              −
            </QuantityButton>
            <QuantityDisplay>{quantity}</QuantityDisplay>
            <QuantityButton onClick={() => handleQuantityChange(1)}>
              +
            </QuantityButton>
          </QuantityControls>
          
          <InfoRow>
            <InfoLabel>Rent Price</InfoLabel>
            <InfoValue>{totalPrice.toLocaleString()} $PXL</InfoValue>
          </InfoRow>
          
          <RentButton onClick={handleRent}>
            Rent Miner
          </RentButton>
        </InfoSection>
      </ModalContainer>
    </ModalOverlay>,
    portalRoot
  );
};

export default BoosterModal;
